import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'kt-date-picker',
  templateUrl: './kt-date-picker.component.html',
  styleUrl: './kt-date-picker.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => KtDatePickerComponent),
      multi: true,
    }
  ],
  encapsulation: ViewEncapsulation.None
})
export class KtDatePickerComponent implements ControlValueAccessor {
  onTouched: () => void = () => { };
  onChange: (_: any) => void = () => { };
  @Output() dateChange: EventEmitter<any> = new EventEmitter();
  @Input() formatString: string;
  @Input() placeholder: string = "MM/DD/YYYY";

  ktDate: FormControl = new FormControl();

  constructor(private datePipe: DatePipe) { }

  onDateChange({ value }) {
    if (this.formatString) {
      const formattedDate = this.datePipe.transform(value, this.formatString);
      this.dateChange.emit(formattedDate);
    } else {
      this.dateChange.emit(value);
    }
    this.onChange(value);
  }

  onBlur() {
    this.onTouched();
  }

  writeValue(value): void {
      this.ktDate.setValue(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.ktDate.disable();
    } else {
      this.ktDate.enable();
    }
  }
}
